import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';
import { trapFocus, removeTrapFocus } from '@shopify/theme-a11y';

import ScrollLock from '../utils/ScrollLock';
import ModalEscCloser from '../utils/ModalEscCloser';

class Modal {
  constructor() {
    this.container = document.querySelector('[data-modal-container]');
    this.drawer = this.container.querySelector('[data-modal]');
    this.header = this.container.querySelector('[data-modal-header]');
    this.closeButton = this.container.querySelector('[data-modal-close]');
    this.content = this.container.querySelector('[data-modal-content]');

    this.trigger = null;

    this.events = new EventHandler();

    this.events.register(this.closeButton, 'click', () => this.close());

    this.events.register(this.container, 'click', e => {
      if (e.target !== this.container) return;
      this.close();
    });

    this.animation = transition({
      state: 'closed',
      el: this.container,
      stateAttribute: 'data-modal-animation-state',
      stateChangeAttribute: 'data-modal-animation',
    });
  }

  open({ header, content }) {
    this.trigger = document.activeElement;
    ModalEscCloser.add(this);
    ScrollLock.lock(this.drawer);
    this.header.innerHTML = header;
    this.content.innerHTML = content;
    return this.animation.animateTo('open')
      .then(() => {
        trapFocus(this.container);
        return this.container;
      });
  }

  close() {
    ModalEscCloser.remove(this);
    return this.animation.animateTo('closed')
      .then(() => {
        removeTrapFocus(this.container);
        ScrollLock.unlock();
        if (this.trigger) {
          this.trigger.focus();
        }
      });
  }

  unload() {
    ModalEscCloser.remove(this);
    this.events.unregisterAll();
  }
}

export default new Modal();
